<template>
  <z-dialogo
    ref="dialogoLancamento"
    titulo="Dar baixa em Conta a Pagar"
    largura="700px"
    eager
    persistent
    :dividers="true"ß
  >
    <template v-slot:texto>
      <v-form ref="form" v-model="form_valido" lazy-validation>
        <v-row dense>
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="contapagar.documento"
              ref="descricao"
              label="Descrição/Documento"
              autofocus
              filled
              dense
              disabled
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4">
            <z-campo-valor
              v-model="contapagar.valor"
              label="Valor"
              ref="valor"
              dense
              disabled
            ></z-campo-valor>
          </v-col>

          <!-- <v-col cols="12" sm="3">
            <z-campo-valor
              v-model="contapagar.valor_pago"
              label="Valor Pago"
              dense
            ></z-campo-valor>
          </v-col> -->

          <v-col cols="12" sm="4">
            <z-date-picker-menu
              v-model="contapagar.vencimento"
              label="Data Vencimento"
              dense
              disabled
            ></z-date-picker-menu>
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="contapagar.categoria_id"
              dense
              label="Categoria"
              filled
              disabled
              :items="listasStore.contas_pagar_categorias"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-select
              v-model="contapagar.forma_pagamento"
              label="Forma de Pagamento"
              filled
              dense
              :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12">
            <v-autocomplete
              v-model="contapagar.fornecedor_id"
              dense
              label="Fornecedor"
              filled
              disabled
              :items="listasStore.fornecedores"
            ></v-autocomplete>
          </v-col>

        </v-row>

      </v-form>
    </template>


    <template #actions_left>
      <v-switch 
        v-if="!isCriando"
        v-model="contapagar.pago" 
        class="my-0 shrink" 
        color="primary" 
        label="Pago"
        :true-value="1"
        :false-value="0"
        hide-details 
      ></v-switch>
    </template>

    <template #actions_right>
      <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
      <v-btn
        color="primary"
        depressed
        :loading="salvando"
        :disabled="salvando || !form_valido"
        @click="confirmarLancamento"
        >Pagar</v-btn>

    </template>

  </z-dialogo>
</template>

<script setup>
import { ref, computed, inject } from 'vue';
import queryBuilder from '@/app/helpers/QueryBuilder';
import { useContasPagarStore } from '@/app/store/pinia/contaspagar.js';
import { useListasStore } from '@/app/store/pinia/listas.js';
import { valorBR } from '@/app/helpers/formatacoes.js';

const props = defineProps({
  titulo: {
    type: String,
    default: "Lançamento de Conta a Pagar"
  },
  operacao: {
    type: String,
    default: "criando" // pode ser "criando", "pagando" ou "editando"
  }
});

const $notificacao = inject('notificacao');

const contasPagarStore = useContasPagarStore();
const listasStore = useListasStore();

const dialogoLancamento = ref(null);

const isCriando = computed(() => props.operacao === "criando");
const isPagando = computed(() => props.operacao === "pagando");
const isEditando = computed(() => props.operacao === "editando");

const salvando = ref(false);
const form_valido = ref(false);
const form = ref(null);

const textoSalvar = computed(() => {
  if (isCriando.value) return "Salvar";
  if (isPagando.value) return "Pagar";
  return "Salvar";
});

const regras = {
  descricao: [(v) => !!v || "O campo descrição é obrigatório"],
  valor: [(v) => v != "0,00" || "O campo valor não pode ser zero"],
  forma_pagamento: [
    (v) => !!v || "O campo forma de pagamento é obrigatório",
  ],
  obrigatorio: [v => !!v || "Campo obrigatório"]
};

const contapagar = computed(() => {
  return contasPagarStore.contapagar;
});

const parcelado = computed(() => {
  if (contapagar.value.valor === 0 || contapagar.value.parcelas < 1) {
    return "";
  }

  if (contapagar.value.dividir_parcelar === "Repetir") {
    return `${contapagar.value.parcelas}x de R$ ${valorBR(contapagar.value.valor)}` ;
  } else {
    return `${contapagar.value.parcelas}x de R$ ${valorBR(contapagar.value.valor / contapagar.value.parcelas)}`;
  }
});

const getListas = async () => {
  await listasStore.fetchListas([
    queryBuilder()
      .from("ContaPagarCategoria")
      .selectraw("id as value, descricao as text, tipo")
      .orderBy("descricao")
      .where("tipo='Despesa'")
      .build(),
    queryBuilder()
      .from("Fornecedor")
      .selectraw("id as value, razao as text")
      .orderBy("razao")
      .build()
  ]);
};


async function confirmarLancamento() {

  if (form.value.validate()) {
    salvando.value = true;
    try {
      await contasPagarStore.pagar(contapagar.value);
      await contasPagarStore.listar({})
      dialogoLancamento.value.fechar();
    } catch (error) {
      // $notificacao.error("Não foi possível salvar o lançamento.", error);
      throw error;
    } finally {
      salvando.value = false;
    }
  }
}

async function abrir() {
  await getListas();
  // contapagar.value.valor_pago = contapagar.value.valor;
  dialogoLancamento.value.abrir();
}

function fechar() {
  dialogoLancamento.value.fechar();
}

defineExpose({
  abrir,
  fechar
});

</script>

<style lang="scss" scoped>

</style>